import { Icon } from "../../../../../components";

export const StorefrontSupplierCardPaymentWithDepositBanner = () => {
  return (
    <div className="flex items-center justify-center border-t border-b border-solid bg-zinc-50 px-3 py-1.5">
      <div className="inline-flex items-center gap-1">
        <Icon icon={"DEPOSIT_PAYMENT"} className="text-zinc-800" />
        <p className={"text-sm font-medium text-zinc-800"}>
          30% deposit required for all orders
        </p>
      </div>
    </div>
  );
};
